import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
  Box,
  Collapse,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import { E2eTestRunResult } from "services/KnowfullyAdminClient";
import RunStatsSummary from "./RunStatsSummary";
import SuiteSection from "./SuiteSection";

type RunRowsProps = {
  run: E2eTestRunResult;
};

const RunRows = ({ run }: RunRowsProps) => {
  const [open, setOpen] = useState(false);
  const hasSuites = (run.suites?.length ?? 0) > 0;

  return (
    <>
      <TableRow hover sx={{ "& > td": { borderBottom: open ? "none" : undefined } }}>
        <TableCell sx={{ width: 40, py: 0.5 }}>
          {hasSuites && (
            <IconButton size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon fontSize="small" /> : <KeyboardArrowDownIcon fontSize="small" />}
            </IconButton>
          )}
        </TableCell>
        <TableCell>
          {new Date(run.runDate as unknown as string).toLocaleString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
            timeZone: "America/New_York",
            timeZoneName: "short",
          })}
        </TableCell>
        <TableCell>
          <RunStatsSummary run={run} />
        </TableCell>
        <TableCell align="right">
          <Tooltip title="Open HTML report">
            <IconButton
              size="small"
              component="a"
              href={run.reportUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <OpenInNewIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>
      {hasSuites && (
        <TableRow>
          <TableCell colSpan={4} sx={{ py: 0, px: 0 }}>
            <Collapse in={open} unmountOnExit>
              <Box sx={{ px: 2, pb: 2, pt: 1, backgroundColor: "action.hover" }}>
                {run.suites?.map((suite) => (
                  <SuiteSection key={suite.title} suite={suite} />
                ))}
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default RunRows;
